import { createContext, useContext, useMemo } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { clearAppSessionState } from '../utils/clearAppSessionState';

const AuthContext = createContext(null);

export function AuthProviderKC({ children }) {
    const { keycloak } = useKeycloak();

    const value = useMemo(() => ({
        authenticated : keycloak.authenticated,
        token         : keycloak.token,
        user          : keycloak.tokenParsed,  // username, email, roles…
        login         : (options) => keycloak.login(options),
        logout        : (options = {}) => {
            // Limpa paginação/filtros/seleção da aba p/ não vazar entre logins.
            clearAppSessionState();
            keycloak.logout({ redirectUri: window.location.origin, ...options });
        },
    }), [keycloak.authenticated, keycloak.token, keycloak.tokenParsed]);

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
}

export function useAuth() {
    const value = useContext(AuthContext);

    if (!value) {
        throw new Error('useAuth must be used within AuthProviderKC');
    }

    return value;
}

export default AuthContext;
